
import { Component, mixins } from 'nuxt-property-decorator';
import { RouteContextMixin, OrganizationMixin } from '~/mixins';
import App from '@/components/layout/App.vue';
import SideNav from '@/components/navigation/SideNav.vue';

const floatingSideNavCookieName = 'opnav_floating';

@Component({
  components: {
    App,
    SideNav,
  },
})
export default class DefaultLayout extends mixins(RouteContextMixin, OrganizationMixin) {
  isSideNavFloating = false;

  created() {
    this.isSideNavFloating = !!this.$cookies.get(floatingSideNavCookieName);
  }

  toggleSideNavMode() {
    this.isSideNavFloating = !this.isSideNavFloating;
    this.$cookies.set(floatingSideNavCookieName, this.isSideNavFloating, {
      path: '/',
      expires: this.$moment().add(1, 'year').toDate(),
    });
  }
}
